import * as T from './appTokenTypes';

export const validateAppTokenRequest = () => ({
  type: T.VALIDATE_APP_TOKEN_REQUEST as typeof T.VALIDATE_APP_TOKEN_REQUEST,
});

export const validateAppTokenSuccess = (valid: boolean) => ({
  type: T.VALIDATE_APP_TOKEN_SUCCESS as typeof T.VALIDATE_APP_TOKEN_SUCCESS,
  payload: valid,
});

export const validateAppTokenFailure = (error: string) => ({
  type: T.VALIDATE_APP_TOKEN_FAILURE as typeof T.VALIDATE_APP_TOKEN_FAILURE,
  payload: error,
});

export const resetAppToken = () => ({
  type: T.RESET_APP_TOKEN as typeof T.RESET_APP_TOKEN,
});
